import React from 'react';
import LoadIndicator from '../../components/common/loading/LoadIndicator';
import Header from '../../components/careers/Header';
import Disciplines from '../../components/careers/Disciplines';
import Carousel from '../../components/careers/Carousel';
import Contact from '../../components/careers/Contact';
import PropertiesComponent from '../../components/careers/Properties';
import {getBowserState} from '@epic-core/common';
import {getHelmetForMetaTags} from '../../utils/epicGamesUtils';
import {getInitialCmsPageSharedValues, PageData, useCmsData} from 'epic-ue-shared';
import Error404 from '../error/Error404';

export interface CareersHeaderData {
    background: {
        content: string[];
        mobileImage: string;
        tabletImage: string;
        type: string;
    };
    buttonHref: string;
    buttonlabel: string;
    content: string;
    secondaryButtonHref: string;
    secondaryButtonLabel: string;
    title: string;
}

export interface CareersPageData extends PageData {
    carousel: {
        items: {
            bgColor: string;
            bgImageMobileURL: string;
            bgImageURL: string;
            buttonlabel: string;
            buttonLink: string;
            description: string;
            title: string;
            type: string;
        }[];
    };
    contact: {
        buttonHref: string;
        buttonLabel: string;
        eeoHref: string;
        eeoLabel: string;
        formHref: string;
        formLabel: string;
        linkHref: string;
        linkLabel: string;
        subTitle: string;
        title: string;
    };
    header: CareersHeaderData;
    properties: {
        items: {
            description: string;
            title: string;
        }[];
        title: string;
    };
    tiles: {
        title: string;
        subTitle: string;
        discipline: {
            description: string;
            image: string;
            title: string;
            url: string;
        }[];
    };
    faq: {
        faqList: {
            answer: string;
            question: string;
        }[];
    };
    leadIn: {
        desc: string;
        title: string;
    };
}

const cmsUrlPattern = '/careers';

const CareersView = (): JSX.Element => {
    const {cmsLoading, cmsLoadedEmpty, pageData} = useCmsData<CareersPageData>(cmsUrlPattern);

    if (cmsLoading) {
        return (
            <div className="careers-view" key="careers-overview">
                <LoadIndicator key="careers-overview-loading" />
            </div>
        );
    }

    if (cmsLoadedEmpty) {
        return <Error404 />;
    }

    const headerData = pageData.header || ({} as CareersHeaderData);
    const tilesData = pageData.tiles || {};
    const carouselData = pageData.carousel || {};
    const contactData = pageData.contact || {};
    const propertiesData = pageData.properties || {};
    const background = headerData.background || {};
    const {mobile, tablet} = getBowserState();

    return (
        <div className="careers-view" key="careers-overview">
            {getHelmetForMetaTags(pageData)}
            <Header
                background={background}
                headerData={headerData}
                mobile={mobile}
                tablet={tablet}
            />
            <Disciplines disciplines={tilesData} />
            <Carousel slides={carouselData} mobile={mobile} tablet={tablet} />
            <PropertiesComponent properties={propertiesData} />
            <Contact contactData={contactData} />
        </div>
    );
};

CareersView.getInitialSharedValues = getInitialCmsPageSharedValues(cmsUrlPattern);

export default CareersView;
